<template>
    <div>
        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Promet: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-promet-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                >
                </skup-promet-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupoviNavigation from "../SkupNavigation";
import SkupPrometForma from "./SkupPrometForma";
export default {
    name: "SkupStavkaEdit",
    components: { SkupPrometForma, SkupoviNavigation },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.promet_id,
            skup_id: this.$route.params.skup_id,
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/promet',
                    name: 'Promet'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/promet/' + this.id,
                    name: 'Promet: ' + this.naziv
                },
                {
                    path: '/skupovi/' + this.skup_id + '/promet/' + this.id + '/edit',
                    name: 'Uredi promet: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.osoba.ime + ' ' + data.osoba.prezime + ' (' + data.osoba.oib + ' )'
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
